module.exports = __webpack_public_path__ + "static/img/12.c4405e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/12.png
// module id = PS/R
// module chunks = 0